<template>
<!-- 顶部 -->
  <Layou class="search_layou search1 px_1" header mian right>
<template v-slot:header>

      <Header />
    </template>
    <template v-slot:main>
      <div class="rong-summay-search-head">

        <div class="rong-summary-search-box">
          <input type="text" placeholder="请输入搜索内容" v-model="k" @input="searchChange"><button>搜索</button>
        </div>
      </div>
      <ul class="rong-summary-search-list">
        <li v-for="(item,index) in searchList" :key="index+''+item.pid" @click="chmgo(item.pid)">
          <h4 :title="item.title" v-html="item.title"></h4>
          <p class="rong-summary-search-source"><span>发布时间：{{item.createTime}} </span>
          <p class="rong-summary-search-text" v-html="item.name"></p>
          <p class="rong-summary-search-text">{{item.account}}</p>
          <p class="rong-summary-search-source"><span>来自: </span>
          <span v-if="item.p_name2">
             {{item.p_name2}}  &gt;
          </span>
          <span v-if="item.p_name">
             {{item.p_name}} &gt;
          </span>
          <span v-if="item.name">
             {{item.name}}
          </span>
           </p>
          <strong class="rong-search-summary-header-platform" style="color: rgb(204, 102, 255);"> {{item.p_name}}</strong>
          <hr>
          </li>

      </ul>
       <template v-if="count>4">
        <el-pagination
          :current-page="pageIndex"
          @current-change="getPageIndex"
          background
          layout="prev, pager, next"
          :page-size="pagesize"
          :total="count"
          >
        </el-pagination>
      </template>
    </template>
    <template v-slot:right>
      <div class="rong-summary-recommend">
        <div class="rong-summary-recommend-box">
        <div class="rong-summary-recommend-box">
          <h5>常见问题</h5>
          <li v-for="(item,index) in product" :key="index+''+item.pid"><a :href="'/?pid='+item.id+''" target="_blank">{{item.name}}</a></li>
        </div>
        </div>
      </div>
    </template>
       <div class="rong-summay-search-head-back"></div>
    </Layou>


</template>

<script>
import Layou from "../components/Layou/index.vue";
import Header from "../components/MxChm/Header.vue"
    export default {
      components: {
        Layou,
        Header,
      },
      name: "search",
      data(){
        return{
          logo: require("../assets/img/logo2.png"),
          activeIndex: "1",
          userinfo: {},
          keywords:"",
          k:"",
          count:"",
          pageIndex:0,
          pagesize:"",
          searchList: [

          ],
          product:[],
        }
      },
       mounted: function () {
           this.k = this.$route.query.k;
           this.get(this.pageIndex,this.k);
       },
       methods: {
         getPageIndex(e) {
      // console.log(e,'index')
      // return;
      // this.pageIndex = e-1;
        var index = e;
        var k = this.k;
        this.get(index, k);
    },
    get(index, keywords) {
      var that = this;
      var pageIndex;
      if (index > 1) {
        pageIndex = index - 1;
      } else {
        pageIndex = 0;
      }

      //发送get请求
      this.$api
        .get("/search?k=" + keywords + "&pageIndex=" + pageIndex)
        .then(
          function (res) {
            // console.log(res);
            that.userInfo = res.data.userInfo;
            that.searchList = res.data.page.list;
            console.log(that.searchList)
            that.count = res.data.page.count;
            that.pageIndex = res.data.page.index + 1;
            that.pagesize = res.data.page.size;
            that.product = res.data.product;
          },
          function () {
            that.$message.error("服务器异常，请稍后重试！");
          }
        );
    },
    searchChange(){

        this.$router.push({ name: 'search',query: { k: this.k }})
         //console.log(this.k,this.$route.query.k,'-----')
          // this.$router.history.current.query.k = this.k;
          // this.$route.query.k = this.k;
          this.get(this.pageIndex,this.k)
         // console.log(this.k,'------------------------')
    },
         chmgo(pid){
           //location.href = "/MxChm?pid="+pid+"&keywords="+this.k;
           window.open("/MxChm?pid="+pid+"&keywords="+this.k)
         }
       }
    }
</script>

<style>
  .search_layou  .content {
    padding: 0 10% 0 19%;
  }

  .search_layou.layou .header {
    padding: 0 16.5%;
  }

  @media screen and (max-width: 1783px) {
    .search_layou.layou .content {
      padding: 0 10% 0 19%;
    }
    .search_layou.layou .header {
      padding: 0 10%;
    }
    .left:before {
      right: 90%;
    }
  }
  @media screen and (max-width: 1263px) {
    .search_layou.layou .content {
      padding: 0 5%;
    }
    .search_layou.layou .header {
      padding: 0 5%;
    }

    .left:before {
      right: 95%;
    }
  }
  .el-main {
    padding: 0;
  }
</style>
<style scoped>



.search{
  padding: 0 16.5%;
}
.rong-summay-search-head {
    height: 120px;
    position: relative;
    transform: translateX(-50%);
    left: 50%;
  }
  .rong-serp-summary * {
    border: none;
    outline: none;
  }
.rong-summary-search-box {
    position: absolute;
    top: 50%;
    left: 47%;
    width: 100%;
    transform: translate(-50%,-50%);
    height: 48px;
    }
    .rong-summay-search-head-back {
    position: absolute;
    width: 100%;
    background-color: #f2f3f6;
    height: 120px;
    z-index: -100;
    top: 60px;
    transform: translateX(-50%);
    left: 50%;
    }
    .rong-summary-search-box input {
    border: 1px #999 solid;
    display: inline-block;
    width: 60%;
    height: 92%;
    padding-left: 10px;
    box-sizing: border-box;
    vertical-align: middle;
    outline: none;
    font-size: 16px;
    }
    .rong-summary-search-box button {
    height: 92%;
    width: 80px;
    font-size: 16px;
    background-color: #09f;
    text-align: center;
    vertical-align: middle;
    color: #fff;
    cursor: pointer;
    box-sizing: border-box;
    outline: none;
    border: none;
    }
.rong-summary-search-list {
    width: 100%;
    padding: 0;
    text-align: left;
}
.rong-summary-search-list li {
    width: 100%;
    list-style: none;
    cursor: pointer;
    position: relative;
}
.rong-summary-search-list h4 {
    color: #373d41;
    line-height: 24px;
    font-size: 18px;
    margin: 37px 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: 80px;
    font-weight: 500;
}
.rong-summary-search-list h4:hover {
    color: #09f;
}
.rong-summary-search-list .rong-summary-search-text {
    font-size: 14px;
    margin-top: 8px;
    color: #666;
    line-height: 24px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    white-space: normal;
}
.rong-summary-search-list .rong-summary-search-source {
    margin-top: 8px;
    color: #999;
    font-size: 14px;
}
.rong-summary-search-list .rong-summary-search-source a{
    color: #999;
    font-size: 14px;
    text-decoration: none;
}
.rong-search-summary-header-platform {
    margin-left: 2px;
    background: transparent;
    padding: 3px 10px;
    display: inline;
    font-size: 12px;
    border: 1px solid!important;
    letter-spacing: .2px;
    font-weight: 500;
    position: absolute;
    right: 0;
    min-width: 50px;
    text-align: center;
    top: -5px;
    height: 16px;
    overflow: hidden;
}
.rong-summary-recommend {
    width: 150px;
    margin-left: 20px;
}
.rong-summary-recommend-box {
    margin-top: 30px;
}
.rong-summary-recommend h5 {
    font-size: 16px;
    color: #333;
    margin: 20px 0;
    font-weight: 500;
    line-height: 1.25;
}
.rong-summary-recommend li {
    margin:  10px 0;
    list-style: none;
}
.rong-summary-recommend li a {
    font-size: 14px;
    color: #666;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
}



.search .right{
  margin-top: 120px;
}



</style>



// WEBPACK FOOTER //
// src/components/search.vue